














































import {
  Component, Ref, Vue, Watch
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AppState } from '@/store/modules/app/types';
import {
  ScenariosAction,
  ScenariosActionType,
  ScenariosGetter,
  ScenariosGetterType,
  ScenariosState
} from '@/store/modules/scenarios/types';
import { Models } from '@mtap-smartcity/api';
import ScenarioPropertiesList
  from '@/components/TheMainCard/PlanningCard/PlanningCardScenariosTab/PlanningCardRightSidePanel/AssignSettings/ScenarioPropertiesList/ScenarioPropertiesList.vue';

const scenarios = namespace('scenarios');
const app = namespace('app');

@Component({
  components: {
    ScenarioPropertiesList
  }
})
export default class AssignSettings extends Vue {
  @Ref() scenarioPropertiesForm!: any;

  editState = false;

  elementKey = 1;

  scenarioData: Models.Scenarios.Model | null = null;

  @app.State
  userActionStatus!: AppState['userActionStatus'];

  @scenarios.State
  scenarios!: ScenariosState['scenarios'];

  @scenarios.State
  selectedScenarioUuid!: ScenariosState['selectedScenarioUuid'];

  @scenarios.Getter(ScenariosGetter.GetScenarioByUuid)
  getScenarioByUuid!: ScenariosGetterType['GET_SCENARIO_BY_UUID'];

  @scenarios.Action(ScenariosAction.UpdateScenario)
  updateScenario!: ScenariosActionType['UPDATE_SCENARIO'];

  get selectedScenario() {
    return this.selectedScenarioUuid ? this.getScenarioByUuid(this.selectedScenarioUuid) : null;
  }

  get scenarioParameters() {
    if (this.editState && this.scenarioData) {
      return this.scenarioData;
    }
    if (this.selectedScenarioUuid) {
      return this.getScenarioByUuid(this.selectedScenarioUuid);
    }
    return null;
  }

  edit() {
    this.editState = true;
  }

  cancel() {
    this.resetChanges();
    this.editState = false;
  }

  save() {
    this.updateScenario(this.scenarioData as Models.Scenarios.Model)
      .catch(() => {
        this.resetChanges();
      })
      .finally(() => {
        this.editState = false;
      });
  }

  updateScenarioProperties(property: { name: string, value: string | number }) {
    this.scenarioData = this.selectedScenario!;
    if ((property.name === 'latitude' || property.name === 'longitude') && this.scenarioData?.location === null) {
      this.scenarioData.location = {
        type: 'Point',
        coordinates: [0, 0]
      };
    }
    if (property.name === 'longitude') {
      this.scenarioData.location.coordinates[0] = parseFloat(property.value as string);
    }
    if (property.name === 'latitude') {
      this.scenarioData.location.coordinates[1] = parseFloat(property.value as string);
    }
  }

  @Watch('selectedScenarioUuid')
  onSelectedScenarioChanged() : void {
    this.elementKey += 1;
  }

  resetChanges() {
    this.scenarioData = JSON.parse(JSON.stringify(this.selectedScenario));
    this.elementKey += 1;
  }
}
